@if (visible()) {
  <p-dialog
    [(visible)]="visible"
    [closable]="false"
    [modal]="true"
    appendTo="body"
    styleClass="w-[21.475rem] h-[30rem] a2hs-notification"
    contentStyleClass="px-4 pt-0 pb-4 flex flex-col gap-8"
  >
    <ng-template pTemplate="header">
      <h2 class="h2-mobile text-center">Add Externi to Your Home Screen</h2>
    </ng-template>
    <ng-template pTemplate="content">
      <span class="body-1-regular-mobile text-grey-5 text-center"
        >Add Externi to your home screen to access it faster with native
        app-like feel</span
      >
      @for (item of instructions; let index = $index; track index) {
        <div class="flex flex-col gap-2">
          <span class="body-1-semibold">{{ index + 1 }}. {{ item.title }}</span>
          <span class="body-1-regular text-grey-6">{{ item.description }}</span>
          <img [src]="item.image" alt="Instruction Icon" class="mt-2" />
        </div>
      }
    </ng-template>
    <ng-template pTemplate="footer">
      <div class="flex items-center gap-6">
        <p-button
          size="large"
          text="true"
          label="Dismiss"
          styleClass="px-4 h-12"
          (onClick)="onClose()"
        />
        <p-button
          size="large"
          label="Got It"
          class="w-full"
          styleClass="min-w-full h-12"
          (onClick)="onClose()"
        />
      </div>
    </ng-template>
  </p-dialog>
}
